export default __webpack_public_path__ + "static/media/02.d40fdec0.jpeg";